// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type MandantenListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type SearchMandantenQuery = {
  search?: string;
  filtered?: string;
  page?: number;
  limit?: number;
  sort?: string;
};

export function useSearchMandanten(): (
  query: SearchMandantenQuery
) => Promise<MandantenListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (query = {}) =>
      (await getAPI()).mandanten.searchMandanten({ ...query }),
    [getAPI]
  );
}
